import React, { useState, useEffect } from 'react';
import { styled } from "@mui/material/styles";
import { Dialog, DialogTitle, DialogContent, DialogActions, IconButton, Button, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import upload_image from '../../Admin/assets/icons/uploaded-image.svg';
import Grid from "@mui/material/Grid2";
import order_info from '../../Admin/assets/icons/orders-info.svg';
import edit from '../../Admin/assets/icons/edit.svg'
import SouthIcon from '@mui/icons-material/South';
import Image from '../../Utils/getImage';
import instance from '../../Utils/api';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));


const Viewpayment = ({ selectedPayment, openviewDialog, setopenviewDialog, }) => {
    const [paymentDetails, setPaymentDetails] = useState(null); // State for paymentDetails


    //handle close
    const handleClose = () => {
        setopenviewDialog(false);
    };

    // Fetch order details by ID
    const fetchPaymentDetailsById = async () => {
        try {
            const response = await instance.get(`/Payment/getPaymentById?payment_id=${selectedPayment._id}`);
            setPaymentDetails(response?.data?.data); // Set fetched data to state
        } catch (error) {
            console.error("Error fetching payments details:", error.message);
        }
    };

    useEffect(() => {
        fetchPaymentDetailsById()
    }, [selectedPayment]);

    return (
        <React.Fragment>
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={openviewDialog}
                className="admin-admins"
            >
                <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
                    payment info
                    <Typography>
                        See the payment details for more information
                    </Typography>
                </DialogTitle>
                <hr style={{ margin: "8px 0px" }} />
                <IconButton
                    aria-label="close"
                    onClick={handleClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent dividers>
                    <section className="add-order">
                        <div className='add-employee-title'>
                            <Typography>Payment Booking Details</Typography>
                        </div>
                        <Grid container spacing={2} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: "flex-start" }}>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 3 }}>
                                <div className="add_emloyee-upload-file">
                                    <Image src={paymentDetails?.customer_id?.profile_pic} alt="profile_pic" />
                                    <Typography variant="h5">{paymentDetails?.customer_id?.name ? paymentDetails?.customer_id?.name : "----"}</Typography>
                                </div>
                            </Grid>
                            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 9 }}>
                                <div className="order-content-text">
                                    <Typography variant="h5">Order details</Typography>
                                </div>
                                <div className='add_emloyee-content'>
                                    <div className='add_emloyee-content-text-2'>
                                        <Typography variant='h5'>Payment Status</Typography>
                                        <Typography>{paymentDetails?.order_id?.payment_status ? paymentDetails?.order_id?.payment_status : '---'}</Typography>
                                    </div>
                                    <div className='add_emloyee-content-text-2'>
                                        <Typography variant='h5'>Paid Amount</Typography>
                                        <Typography>{paymentDetails?.order_id?.paid_amount ? paymentDetails?.order_id?.paid_amount : '---'}</Typography>
                                    </div>
                                    <div className='add_emloyee-content-text-2'>
                                        <Typography variant='h5'>Payment Amount</Typography>
                                        <Typography>{paymentDetails?.order_id?.payment_amount}</Typography>
                                    </div>
                                    <div className='add_emloyee-content-text-2'>
                                        <Typography variant='h5'>Pending Amount</Typography>
                                        <Typography>{paymentDetails?.order_id?.pending_amount ? paymentDetails?.order_id?.pending_amount : '---'}</Typography>
                                    </div>
                                </div>
                                <div className='add_emloyee-content'>
                                    <div className='add_emloyee-content-text'>
                                        <Typography variant='h5'>Order Status</Typography>
                                        <Typography>{paymentDetails?.order_id?.status ? paymentDetails?.order_id?.status : '---'}</Typography>
                                    </div>
                                    <div className='add_emloyee-content-text'>
                                        <Typography variant='h5'>Total Amount</Typography>
                                        <Typography>{paymentDetails?.order_id?.total_amount ? paymentDetails?.order_id?.total_amount : '---'}</Typography>
                                    </div>
                                    <div className='add_emloyee-content-text'>
                                        <Typography variant='h5'>Ordered date</Typography>
                                        <Typography>{new Date(paymentDetails?.createdAt).toLocaleString()}</Typography>
                                    </div>
                                    <div className='add_emloyee-content-text'>
                                        <Typography variant='h5'>Delivered Date</Typography>
                                        <Typography>{new Date(paymentDetails?.updatedAt).toLocaleString()}</Typography>
                                    </div>
                                </div>
                                <div className="order-content-text" style={{ marginTop: 40 }}>
                                    <Typography variant="h5">Customer details</Typography>
                                    <div className='add_emloyee-content'>
                                        <div className='add_emloyee-content-text'>
                                            <Typography variant='h5'>Name</Typography>
                                            <Typography>{paymentDetails?.customer_id?.name ? paymentDetails?.customer_id?.name : "----"}</Typography>
                                        </div>
                                        <div className='add_emloyee-content-text'>
                                            <Typography variant='h5'>mobile</Typography>
                                            <Typography>{paymentDetails?.customer_id?.mobile ? paymentDetails?.customer_id?.mobile : "----"}</Typography>
                                        </div>
                                        <div className='add_emloyee-content-text'>
                                            <Typography variant='h5'>Birth Date</Typography>
                                            <Typography>{paymentDetails?.customer_id?.dob ? new Date(paymentDetails?.customer_id?.dob).toLocaleDateString() : "----"}</Typography>
                                        </div>
                                        <div className='add_emloyee-content-text'>
                                            <Typography variant='h5'>Gender</Typography>
                                            <Typography>{paymentDetails?.customer_id?.Gender ? paymentDetails?.customer_id?.Gender : "----"}</Typography>
                                        </div>
                                    </div>
                                    <div className='add_emloyee-content'>
                                        <div className='add_emloyee-content-text'>
                                            <Typography variant='h5'>Size</Typography>
                                            <Typography>{paymentDetails?.customer_id?.size ? paymentDetails?.customer_id?.size : "----"}</Typography>
                                        </div>
                                        <div className='add_emloyee-content-text'>
                                            <Typography variant='h5'>location</Typography>
                                            <Typography>{paymentDetails?.customer_id?.location ? paymentDetails?.customer_id?.location : "----"}</Typography>
                                        </div>
                                        <div className='add_emloyee-content-text'>
                                            <Typography variant='h5'>Consultations Left</Typography>
                                            <Typography>{paymentDetails?.customer_id?.consultations_left === true ? 'Active' : 'Inactive' ? paymentDetails?.customer_id?.consultations_left === true ? 'Active' : 'Inactive' : "----"}</Typography>
                                        </div>
                                        <div className='add_emloyee-content-text'>
                                            <Typography variant='h5'>status</Typography>
                                            <Typography>{paymentDetails?.customer_id?.status === true ? 'Active' : 'Inactive' ? paymentDetails?.customer_id?.status === true ? 'Active' : 'Inactive' : "----"}</Typography>
                                        </div>
                                    </div>
                                </div>
                            </Grid>
                        </Grid>
                    </section>
                    <hr style={{ margin: "10px 0px" }} />
                    {paymentDetails?.order_id?.assigned_to &&
                        <section className="add-order">
                            <div className='add-employee-title'>
                                <Typography>Assigned Person info</Typography>
                                {/* <Button>Edit <img src={edit} alt='edit' /></Button> */}
                            </div>
                            <Grid container spacing={2} sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: "flex-start" }}>
                                <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 3 }}>
                                    <div className="add_emloyee-upload-file">
                                        <Image src={paymentDetails?.order_id?.assigned_to?.profile_pic} alt="profile_pic" />
                                        <Typography variant="h5">{paymentDetails?.order_id?.assigned_to?.name ? paymentDetails?.order_id?.assigned_to?.name : "----"}</Typography>
                                    </div>
                                </Grid>
                                <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 9 }}>
                                    <div className='add_emloyee-content'>
                                        <div className='add_emloyee-content-text'>
                                            <Typography variant='h5'>Mobile number</Typography>
                                            <Typography>{paymentDetails?.order_id?.assigned_to?.mobile ? paymentDetails?.order_id?.assigned_to?.mobile : "----"}</Typography>
                                        </div>
                                        <div className='add_emloyee-content-text'>
                                            <Typography variant='h5'>Role</Typography>
                                            <Typography>{paymentDetails?.order_id?.assigned_to?.role ? paymentDetails?.order_id?.assigned_to?.role : "----"}</Typography>
                                        </div>
                                        <div className='add_emloyee-content-text'>
                                            <Typography variant='h5'>Email</Typography>
                                            <Typography>{paymentDetails?.order_id?.assigned_to?.email ? paymentDetails?.order_id?.assigned_to?.email : "----"}</Typography>
                                        </div>
                                    </div>
                                    <div className='add_emloyee-content' >
                                        <div className='add_emloyee-content-text-2'>
                                            <Typography variant='h5'>Address</Typography>
                                            <Typography>{paymentDetails?.order_id?.assigned_to?.address ? paymentDetails?.order_id?.assigned_to?.address : "----"}</Typography>
                                        </div>
                                        <div className='add_emloyee-content-text-2'>
                                            <Typography variant='h5'>Alternate mobile</Typography>
                                            <Typography>{paymentDetails?.order_id?.assigned_to?.alt_mobile ? paymentDetails?.order_id?.assigned_to?.alt_mobile : "----"}</Typography>
                                        </div>
                                        <div className='add_emloyee-content-text-2'>
                                            <Typography variant='h5'>Status</Typography>
                                            <Typography>{paymentDetails?.order_id?.assigned_to?.status === true ? 'Active' : 'Inactive' ? paymentDetails?.order_id?.assigned_to?.status : "----"}</Typography>
                                        </div>
                                    </div>
                                </Grid>
                            </Grid>
                        </section>
                    }
                    {/* <hr style={{ margin: "15px 0px" }} />
                    <section className="add-order">
                        <div className='add-employee-title'>
                            <Typography>Previous Bookings</Typography>
                        </div>
                        <CommonTable columns={data.columns} rows={data.rows} />
                    </section> */}
                </DialogContent>
                <DialogActions>
                    <Button
                        className="cancel-btn"
                        onClick={handleClose}>
                        Cancel
                    </Button>
                </DialogActions>
            </BootstrapDialog>
        </React.Fragment>
    )
}

export default Viewpayment;